<template>
  <v-container fluid class="transactions-container">
    <v-row justify="center">
      <v-col cols="12" md="8">
        <v-card>
          <v-card-title class="text-h6 text-center">
            تراکنش‌های من
          </v-card-title>
          <v-data-table
              color="success"
              checkbox-color="success"
              :headers="headers"
              :items="transactions"
              :items-per-page="meta.per_page"
              :page.sync="meta.current_page"
              :loading="loading"
              loading-text="لطفا صبر کنید..."
              dense
              fixed-header
              class="elevation-1 mb-16"
          >
            <template
                v-slot:[`item.status`]="{ item }">
              <span
                  :class="{
                  'text-success': item.status === 'موفق',
                  'text-error': item.status === 'ناموفق',
                  'text-warning': item.status === 'منتظر',
                  'text-muted': item.status === 'لغو شده',
                }"
              >
                {{ item.status }}
              </span>
            </template>
            <template
                v-slot:[`item.method`]="{ item }">
              <span>
                {{ item.method === 'online' ? 'آنلاین'
                  : item.method === 'operator' ? 'اپراتور'
                      : 'اعتباری' }}
              </span>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "TransactionsDesktop",
  data() {
    return {
      headers: [
        { text: "مبلغ", value: "amount", sortable: true },
        { text: "نوع", value: "type", sortable: true },
        { text: "وضعیت", value: "status", sortable: true },
        { text: "روش پرداخت", value: "method", sortable: false },
        { text: "عنوان اشتراک", value: "subscription_title", sortable: false },
        { text: "تاریخ ایجاد", value: "created_at_fa", sortable: true },
      ],
      transactions: [],
      meta: {
        total: 0, // Total records
        per_page: 10, // Records per page
        current_page: 1, // Current page
      },
      loading: true,
    };
  },
  mounted() {
    this.fetchTransactions(); // Fetch entire data on mount
  },
  methods: {
    fetchTransactions() {
      this.loading = true;
      // Fetch the data from the API; handle nested response properly
      window.axios
          .get("/finance/transaction/my")
          .then((res) => {
            let rawData = res.data.data; // Raw response structure

            // Check if paginated data exists
            if (rawData && Array.isArray(rawData.data)) {
              this.transactions = rawData.data.map((transaction) => ({
                ...transaction,
                type: transaction.type === "withdraw" ? "برداشت" : "واریز",
                status:
                    transaction.status === "success"
                        ? "موفق"
                        : transaction.status === "failed"
                            ? "ناموفق"
                            : transaction.status === "waiting"
                                ? "منتظر"
                                : "لغو شده",
              }));
              this.meta.total = rawData.total || 0; // Total record count
              this.meta.per_page = rawData.per_page || 10; // Per page count
              this.meta.current_page = rawData.current_page || 1; // Current page
            } else {
              console.error("Unexpected API response structure:", rawData);
            }
          })
          .catch((err) => {
            console.error("Error fetching transactions:", err);
          })
          .finally(() => {
            this.loading = false;
          });
    },
  },
};
</script>

<style scoped>
.transactions-container {
  margin-bottom: 100px !important;
  direction: rtl;
  font-family: "IRANSans", sans-serif;
}

[v-cloak] {
  display: none;
}
</style>